<template>
  <div class="rightBlock changeShaftTabC">
  <el-container>
    <el-main>
      <div class="tab" style="display: block;">
        <child-axisProductc ref="childAxisProductc"></child-axisProductc>

        <div class="channel">
          <div tip>{{$t("changeShaftTab.tip")}}</div>

          <el-tabs ref="tabs" v-model="shaftName" @tab-click="switchTab">
           
            <el-tab-pane v-if="gateronShow" :label="$t('changeShaftTab.gateronTit')" name="gateron">
              <div info>
                <p>{{$t("axis.gateronInfo")}}</p>
                <el-row style="padding: 0 0px;">
                  <el-button v-on:click="buttonSelect('cancel')" round size="mini" type="info" plain>{{$t("performanceTab.customButtonInfo")}}</el-button>
                  <el-button v-on:click="buttonSelect('wasd')" round size="mini">{{$t("performanceTab.wasd")}}</el-button>
                  <el-button v-on:click="buttonSelect('ud')" round size="mini">{{$t("performanceTab.ud")}}</el-button>
                  <!-- <el-button v-on:click="buttonSelect('wasdud')" round size="mini">{{$t("performanceTab.wasdud")}}</el-button> -->
                </el-row>
              </div>
              <ul>
                <li v-for="gateron in axisAll.gateron" brand="gateron" :model="gateron.model" @click="changeShaftThe">
                  <img :src="axisImg('gateron',gateron.model)" brand="gateron" :model="gateron.model" :RT="gateron.RT" :maxHigth="gateron.maxHigth"/>
                  <p>{{gateron.name}}</p>
                </li>
              </ul>
            </el-tab-pane>

            <el-tab-pane v-if="etShow" :label="$t('changeShaftTab.et')" name="ef">
              <div info>
                <p>{{$t("axis.generalInfo")}}</p>
                <el-row style="padding: 0 0px;">
                  <el-button v-on:click="buttonSelect('cancel')" round size="mini" type="info" plain>{{$t("performanceTab.customButtonInfo")}}</el-button>
                  <el-button v-on:click="buttonSelect('wasd')" round size="mini">{{$t("performanceTab.wasd")}}</el-button>
                  <el-button v-on:click="buttonSelect('ud')" round size="mini">{{$t("performanceTab.ud")}}</el-button>
                  <!-- <el-button v-on:click="buttonSelect('wasdud')" round size="mini">{{$t("performanceTab.wasdud")}}</el-button> -->
                </el-row>
              </div>
              <ul>
                <li v-for="ef in axisAll.ef" brand="ef" :model="ef.model" @click="changeShaftThe">
                  <img :src="axisImg('ef',ef.model)" brand="ef" :model="ef.model" :RT="ef.RT" :maxHigth="ef.maxHigth"/>
                  <p>{{ef.name}}</p>
                </li>
              </ul>
            </el-tab-pane>
            
            <el-tab-pane v-if="kailhShow" :label="$t('changeShaftTab.kailhTit')" name="kailh">
              <div info>
                <p>{{$t("axis.generalInfo")}}</p>
                <el-row style="padding: 0 0px;">
                  <el-button v-on:click="buttonSelect('cancel')" round size="mini" type="info" plain>{{$t("performanceTab.customButtonInfo")}}</el-button>
                  <el-button v-on:click="buttonSelect('wasd')" round size="mini">{{$t("performanceTab.wasd")}}</el-button>
                  <el-button v-on:click="buttonSelect('ud')" round size="mini">{{$t("performanceTab.ud")}}</el-button>
                  <!-- <el-button v-on:click="buttonSelect('wasdud')" round size="mini">{{$t("performanceTab.wasdud")}}</el-button> -->
                </el-row>
              </div>
              <ul>
                <li v-for="kailh in axisAll.kailh" brand="kailh" :model="kailh.model" @click="changeShaftThe">
                  <img :src="axisImg('kailh',kailh.model)" brand="kailh" :model="kailh.model" :RT="kailh.RT" :maxHigth="kailh.maxHigth"/>
                  <p>{{kailh.name}}</p>
                </li>
              </ul>
            </el-tab-pane>

            <el-tab-pane v-if="ttcShow" :label="$t('changeShaftTab.ttcTit')" name="ttc">
              <div info>
                <p>{{$t("axis.generalInfo")}}</p>
                <el-row style="padding: 0 0px;">
                  <el-button v-on:click="buttonSelect('cancel')" round size="mini" type="info" plain>{{$t("performanceTab.customButtonInfo")}}</el-button>
                  <el-button v-on:click="buttonSelect('wasd')" round size="mini">{{$t("performanceTab.wasd")}}</el-button>
                  <el-button v-on:click="buttonSelect('ud')" round size="mini">{{$t("performanceTab.ud")}}</el-button>
                  <!-- <el-button v-on:click="buttonSelect('wasdud')" round size="mini">{{$t("performanceTab.wasdud")}}</el-button> -->
                </el-row>
              </div>
              <ul>
                <li v-for="ttc in axisAll.ttc" brand="ttc" :model="ttc.model" @click="changeShaftThe">
                  <img :src="axisImg('ttc',ttc.model)" brand="ttc" :model="ttc.model" :RT="ttc.RT" :maxHigth="ttc.maxHigth"/>
                  <p>{{ttc.name}}</p>
                </li>
              </ul>
            </el-tab-pane>

            <el-tab-pane v-if="hmShow" :label="$t('changeShaftTab.hmTit')" name="hm">
            </el-tab-pane>
            <el-tab-pane v-if="otherShow" :label="$t('changeShaftTab.other')" name="other">
            </el-tab-pane>

          </el-tabs>	
          
         <div chart>

            <div kedubgc :style="{height: zHeightDefine + 'px',backgroundColor: zMaxAnimationHeightBgColorDefine,}"></div>
            <div kedu></div>
            <div status>
                <div fluctuate>
                  <p>{{$t("performanceTab.fluctuate")}}</p>
                  <span>{{RealTimeJourneyVal}} mm / {{RealTimeJourneyUS}} us</span>
                </div>
                <el-switch v-model="openRealtime" @change="listenJourney" active-text="" :inactive-text="$t('performanceTab.test')"></el-switch>

                <div :style="{'background':'url(' + axisCurZ_B + ') no-repeat','background-size':'cover'}" animation><img :style="{top: zTopDefine + 'px' }"  :src="axisCurZ_Y" width="85" /></div>
            </div>
            <div chartnow>
              <div id="changeShaft" :style="{ width: '300px', height: '200px' }"></div>
            </div>
         </div> 
          
        </div>
      </div>
    </el-main>
  </el-container>
</div>
</template>
<style>
  
#changeShaft
{
  width: 300px;
  height: 202px;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: absolute;
  top: 139px;

}
</style>
<script>

import axis from '../../../../theme/axis.json';
import cmd10 from '../../../../theme/cmd1.0.config.json';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../../../asserts/js/hid_device.js';
import { ToolsHandle } from '../../../../utils/tools.js';

import buttonPaneC from './buttonTabPane/buttonPaneC.vue'
import axisProductC from './buttonTabPane/axisProduct.vue'
export default {
  name: 'changeShaftTabC',
  components: 
  {
    'child-axisProductc':axisProductC
  },
  data() {

    return {
      ThemeConf:null,
      HIDDeviceObj:null,
      shaftName: 'gateron',
      gateronShow:false,
      etShow:false,
      kailhShow:false,
      ttcShow:false,
      hmShow:false,
      otherShow:false,

      option: {},
      showData:1,
      performanceAllButton:3,
      performanceCustomButton:2,
      RTDown:1.0,
      RTUp:0.1,
      openRealtime:false,

      RealTimeJourneyValList:[],
      RealTimeJourneyVal:0,
      RealTimeJourneyUS:0,
      RealTimeJourneyUSAverage:125,
      RealTimeJourneyUSAverageHigh:125,
      RealTimeJourneyUSAverageNormal:240,
      zTopDefine:-31,
      zMaxAnimationDefine:25,

      zHeightDefine:0,
      zMaxAnimationHeightDefine:240,
      zMaxAnimationHeightBgColorDefine:'#e1e1e1',
      zMaxJourneyDefine:4000,
      lineColor:"#929292",
      RTStep:0.01,
      axisAll:[],
      axisCurZ_Y:"",
      axisCurZ_B:""
    }
  },
  mounted() 
  { 

    this.axisAll = axis;
    this.drawLine();
    this.axisCur("","","","");
    this.$refs.tabs.$el.querySelector(".el-tabs__active-bar").style.width = "30px";

  },
  methods: 
  {
    showTab(name)
    {

      this.shaftName = this.ThemeConf.axisTightAlignment[0];
      for(let i in this.ThemeConf.axisTightAlignment)
      {
          if(this.ThemeConf.axisTightAlignment[i] == 'gateron')
          {
             this.gateronShow = true;
          }

          if(this.ThemeConf.axisTightAlignment[i] == 'et')
          {
             this.etShow = true;
          }

          if(this.ThemeConf.axisTightAlignment[i] == 'kailh')
          {
             this.kailhShow = true;
          }

          if(this.ThemeConf.axisTightAlignment[i] == 'ttc')
          {
             this.ttcShow = true;
          }

          if(this.ThemeConf.axisTightAlignment[i] == 'hm')
          {
             this.hmShow = true;
          }

          if(this.ThemeConf.axisTightAlignment[i] == 'other')
          {
             this.otherShow = true;
          }
      }

    },
    //设置自定义轴体
    changeShaftThe(el)
    {
        let brand = el.target.getAttribute("brand");
        let model = el.target.getAttribute("model");
        let rt = el.target.getAttribute("rt");
        let maxHigth = el.target.getAttribute("maxhigth");

        let buttons = document.querySelectorAll('.changeShaftTabC li.select');
        if(buttons.length == 0)
        {//设置全局轴体

            this.$confirm(this.$i18n.t("changeShaftTab.confirmInfo"), this.$i18n.t("changeShaftTab.confirmTit"), 
            {
              confirmButtonText:  this.$i18n.t("changeShaftTab.confirmOK"),
              cancelButtonText: this.$i18n.t("changeShaftTab.confirmNo"),
              type: 'warning'
            }).then(() => 
            {
                this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.changeAxis"), message: this.$i18n.t("msg.changeAxisInfo"),type: 'warning'});
                setTimeout(()=>
                {
                  this.HIDDeviceObj.stopCalibrate(cmd10);
                  this.$notify.closeAll();
                  this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:600,duration:1000});
                },2000);

                //手动校准一次
                this.HIDDeviceObj.startCalibrate(cmd10);

                //设置全局轴体
                this.axisCur(brand,model,rt,maxHigth);
                setTimeout(()=>
                {
                  window.location.reload();

                },3000);

            }).catch(() => {});

        }
        else
        {//自定义按键轴体

            this.$confirm(this.$i18n.t("changeShaftTab.confirmInfo2"), this.$i18n.t("changeShaftTab.confirmTit"), 
            {
              confirmButtonText:  this.$i18n.t("changeShaftTab.confirmOK"),
              cancelButtonText: this.$i18n.t("changeShaftTab.confirmNo"),
              type: 'warning'
            }).then(() => 
            {
                this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.changeAxis"), message: this.$i18n.t("msg.changeAxisInfo"),type: 'warning'});
                setTimeout(()=>
                {
                  this.HIDDeviceObj.stopCalibrate(cmd10);
                  this.$notify.closeAll();
                  this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:600,duration:1000});
                },3000);

                //手动校准一次                
                this.HIDDeviceObj.startCalibrate(cmd10);

                //更新UI
                const childAxisProductc = this.$refs.childAxisProductc;
                      childAxisProductc.setAxisImg(brand,model);
                buttons.forEach(function(el) 
                {
                    el.classList.remove('select');
                    el.classList.remove('on');
                    el.classList.add('has');
                });

            }).catch(() => {});

        }
        
    },
    //自定义轴体
    axisCur(brand,model,rt,maxHigth)
    {
      if(brand == "" || model == "")
      {
          this.axisCurZ_Y =  require("../asserts/image/z_y.png");
          this.axisCurZ_B =  require("../asserts/image/z_b.png");
      }
      else
      {
        try 
        {
          // 尝试导入资源
          this.axisCurZ_Y =  require("../asserts/image/axis/"+ brand +"/" + model +"/z_y.png");
          this.axisCurZ_B =  require("../asserts/image/axis/"+ brand +"/" + model +"/z_b.png");
              localStorage.setItem('axis',JSON.stringify({"brand":brand,"model":model,"RT":rt,"maxHigth":maxHigth}));

        } catch (e) 
        {
          // 资源不存在，捕获错误
          console.error(`资源不存在`);

          this.axisCurZ_Y =  require("../asserts/image/z_y.png");
          this.axisCurZ_B =  require("../asserts/image/z_b.png");
        }
      }
     
    },
    axisImg(brand,model)
    {
      let imgUrl = require("../asserts/image/axis/"+ brand +"/" + model +"/icon.png");   

      return imgUrl;
    },
    //初始化配置数据
    initData()
    {
        this.lineColor = this.ThemeConf.lineColor;
        for(let i in this.ThemeConf.DeviceList)
        {
            if(this.ThemeConf.DeviceList[i].FirmwareVer == this.HIDDeviceObj.FirmwareVer)
            {
              this.RTStep = this.ThemeConf.axisSet.RT;//this.ThemeConf.DeviceList[i].RT;

              if(this.ThemeConf.axisSet.brand != '')
              {
                this.axisCur(this.ThemeConf.axisSet.brand,
                this.ThemeConf.axisSet.model,
                this.ThemeConf.axisSet.RT,
                this.ThemeConf.axisSet.maxHigth);
              }
              else
              {
                this.axisCur(this.ThemeConf.DeviceList[i].axis.brand,
                this.ThemeConf.DeviceList[i].axis.model,
                this.ThemeConf.DeviceList[i].axis.RT,
                this.ThemeConf.DeviceList[i].axis.maxHigth);
              }
              
              break;
            }
        }


        this.showTab();
       
    },
    //初始化刷新数据
    init()
    {
        const childAxisProductc = this.$refs.childAxisProductc;
              childAxisProductc.KeyMap = this.HIDDeviceObj.MatrixList.KeyMap;
              childAxisProductc.HIDDeviceObj = this.HIDDeviceObj;
              childAxisProductc.setProductImagePath();

        //实时行程心电图
        if(this.RealTimeJourneyValList.length == 30)
        {
          this.RealTimeJourneyValList.shift();
        }
        this.RealTimeJourneyValList.push(
        [
          new Date(2024, 9, 1, 0, this.RealTimeJourneyVal * 10000),
          this.RealTimeJourneyVal
        ]);
        this.drawLine();

        //实时行程高度
        this.RealTimeJourneyUS = Math.floor(Math.random() * this.RealTimeJourneyUSAverage) + 1;
        // this.RealTimeJourneyVal = this.HIDDeviceObj.curMaxJourney.toFixed(3);
        this.zMaxAnimationHeightBgColorDefine = this.HIDDeviceObj.curMaxJourneyKeyStatus>1?'#75c54d':'#e1e1e1';

        // this.RealTimeJourneyVal = this.HIDDeviceObj.curMaxJourney + (0.2/38)*(this.HIDDeviceObj.curMaxJourney*10);
        // this.RealTimeJourneyVal = this.RealTimeJourneyVal>4?4:this.RealTimeJourneyVal;
        this.RealTimeJourneyVal = this.HIDDeviceObj.curMaxJourney.toFixed(3);

        this.setZTop();

        //实时行程按键状态
        this.refreshData(this.HIDDeviceObj.MatrixList.KeyMap);

    },
    //读取自定义行程数据
    async readJourneyCustom()
    {
        this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.synData"), message: this.$i18n.t("msg.synDataInfo"),type: 'warning'});
        let buttons = document.querySelectorAll("li");
            buttons.forEach(function(el) 
            {
                el.classList.remove('has');
            });

        this.$notify.closeAll();
        //更新UI
        this.performanceAllButton = this.HIDDeviceObj.journey_global;
        const childAxisProductc = this.$refs.childAxisProductc;
              childAxisProductc.journey_global = this.HIDDeviceObj.journey_global;

    },
    //切换行程
    switchTab(tab, event) 
    {
      

    },
    //选择按键
    buttonSelect(op)
    {
      switch(op)
      {
        case 'cancel':
        {
          let buttons = document.querySelectorAll('.axis li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });

        }break;
        case 'wasd':
        {
          let buttons = document.querySelectorAll('.axis li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });


          let buttonW = document.querySelector('.axis li[name="W"]');
          let buttonA = document.querySelector('.axis li[name="A"]');
          let buttonS = document.querySelector('.axis li[name="S"]');
          let buttonD = document.querySelector('.axis li[name="D"]');
          
              buttonW.classList.add('select');
              buttonA.classList.add('select');
              buttonS.classList.add('select');
              buttonD.classList.add('select');
          
        }break;
        case 'ud':
        {
          let buttons = document.querySelectorAll('.axis li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });


          let buttonU = document.querySelector('.axis li[name="Up"]');
          let buttonD = document.querySelector('.axis li[name="Down"]');
          let buttonL = document.querySelector('.axis li[name="Left"]');
          let buttonR = document.querySelector('.axis li[name="Right"]');

          if(buttonU == null)
          {
            this.$message({message:this.$i18n.t("msg.buttonUWarn"),type: 'warning',center: true,offset:500,duration:1000});
            return;
          }


          buttonU.classList.add('select');
          buttonD.classList.add('select');
          buttonL.classList.add('select');
          buttonR.classList.add('select');

        }break;
        case 'wasdud':
        {

          let buttons = document.querySelectorAll('.axis li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });

          let buttonCW = document.querySelector('.axis li[name="W"]');
          let buttonCA = document.querySelector('.axis li[name="A"]');
          let buttonCS = document.querySelector('.axis li[name="S"]');
          let buttonCD = document.querySelector('.axis li[name="D"]');
          
          buttonCW.classList.add('select');
          buttonCA.classList.add('select');
          buttonCS.classList.add('select');
          buttonCD.classList.add('select');


          let buttonU = document.querySelector('.axis li[name="UP"]');
          let buttonD = document.querySelector('.axis li[name="DOWN"]');
          let buttonL = document.querySelector('.axis li[name="LEFT"]');
          let buttonR = document.querySelector('.axis li[name="RIGHT"]');

          if(buttonU == null)
          {
            this.$message({message:this.$i18n.t("msg.buttonUWarn"),type: 'warning',center: true,offset:500,duration:1000});
            return;
          }

          buttonU.classList.add('select');
          buttonD.classList.add('select');
          buttonL.classList.add('select');
          buttonR.classList.add('select');

        }break;

      }

    },
    //发送获取行程实时信息命令
    listenJourney()
    {

      let buttons = document.querySelectorAll('.BP li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });
          
        this.RealTimeJourneyValList = [];
        this.drawLine();
        if(this.openRealtime)
        {
            this.$confirm(this.$i18n.t("msg.confirmInfo"), this.$i18n.t("msg.confirmTit"), 
            {
              confirmButtonText:  this.$i18n.t("msg.confirmHigh"),
              cancelButtonText: this.$i18n.t("msg.confirmNormal"),
              showClose:false,
              closeOnClickModal:false,
              closeOnPressEscape:false,
              closeOnHashChange:false,
              type: 'warning'
            }).then(() => 
            {
                this.RealTimeJourneyUSAverage = this.RealTimeJourneyUSAverageHigh;
                this.HIDDeviceObj.stopListening();
                this.HIDDeviceObj.startListeningHigh(cmd10);

            }).catch(() => {

              this.RealTimeJourneyUSAverage = this.RealTimeJourneyUSAverageNormal;
              this.HIDDeviceObj.stopListening();
              this.HIDDeviceObj.startListeningNormal(cmd10);
              
            });

        }
        else
        {
          this.HIDDeviceObj.stopListening();
        }
      
    },
    stopJourney()
    {
        this.openRealtime = false;
        this.HIDDeviceObj.stopListening();
    },
    //刷新按键状态
    refreshData(mapData)
    {
        for(let i=0;i<mapData.length;i++)
        {
          for(let j=0;j<mapData[i].length;j++)
          {
              let bottonObj = mapData[i][j];
              let keyName = bottonObj.key_name;
              if(keyName == 0)
                  continue;

              let button = document.querySelector('li[name='+ keyName +']');
              if(!button)
                  continue;

              if(bottonObj.key_status == 2)
              {
                 button.classList.add('on');
              }
              else
              {
                  button.classList.remove('on');
              }

          }
        }
    },
    //刷新绘制心跳图
    drawLine() 
    {
      var context = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("changeShaft"),"macarons2");
      // 绘制图表
      myChart.setOption({
 
        tooltip : {
        trigger: 'item',
        formatter : function (params) {

            return params.value[1];
          }
        },
        grid: 
        {
          // width: 280,
          show: true, // 显示网格
          borderWidth: 1, // 边框宽度
          borderColor: '#ccc', // 边框颜色
          // 网格线的样式
          lineStyle: 
          {
              color: '#ccc', // 网格线颜色
              width: 1, // 网格线宽度
              type: 'solid' // 网格线类型
          },
          y2: 60
        },
        xAxis : 
        [
            {
              show:false,
              type : 'category',
              splitNumber:'auto',
              boundaryGap:false,
              interval: 0
            }
        ],
        yAxis : [
            {
                type : 'value',
                inverse:true,
                min: 0.0, // 设置最小刻度值
                max: 4.0, // 设置最大刻度值
                axisTick: {alignWithLabel: true},
                axisLabel: 
                {
                  formatter: function(value) 
                  {
                      return value.toFixed(1); // 保留一位小数
                  }
                }
            },
        ],
        color: [context.lineColor, context.lineColor, context.lineColor],
        series : [
            {
                name: '实时行程',
                type: 'line',
                showAllSymbol: false,
                smooth: true,
                symbolSize: function (value)
                {
                    return 1;
                },
                data: context.RealTimeJourneyValList
            }
        ]
        });
    },
    //刷新绘制行程刻度尺
    setZTop()
    {
        //按压
        let minTop = this.zMaxAnimationDefine/this.zMaxJourneyDefine;
        this.zTopDefine = -31 + this.RealTimeJourneyVal*1000*minTop;
        this.zTopDefine = this.zTopDefine>this.zMaxAnimationDefine?-31:this.zTopDefine;

        //高度
        let minHeight = this.zMaxAnimationHeightDefine/this.zMaxJourneyDefine;
        this.zHeightDefine = this.RealTimeJourneyVal*1000*minHeight;
        this.zHeightDefine = this.zHeightDefine>this.zMaxAnimationHeightDefine?0:this.zHeightDefine;

    }
  } 
}

</script>